const Error = () => {
    return (
        <div className=' size-28 bg-red-500 rounded-full flex items-center justify-center '>
            <svg className="size-20 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                 fill="none"
                 stroke="currentColor" strokeWidth="3">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </div>
    );
};

export default Error;
